<h3 translate class="page-title text-center">FAVOURITES</h3>
<lib-filter-list #productList [configService]="favouriteProductListConfig"></lib-filter-list>
